import { render, staticRenderFns } from "./PopularInquiriesDrawer.vue?vue&type=template&id=bb6886f0&scoped=true&"
import script from "./PopularInquiriesDrawer.vue?vue&type=script&lang=js&"
export * from "./PopularInquiriesDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PopularInquiriesDrawer.vue?vue&type=style&index=0&id=bb6886f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6886f0",
  null
  
)

export default component.exports